/* tslint:disable */
import * as Types from '../../../../../../graphql-api/gql-api-interfaces';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type DabQueryVariables = Types.Exact<{
  query: Types.DabQuery;
}>;


export type DabQuery = { dab?: Array<{ brandId: string, productId: string, rootId?: string | null, basketItemsQuantity?: number | null, inboundItemsQuantity?: Array<number> | null, deliveredItemsQuantity?: Array<number> | null, hasInboundItemsIcon?: boolean | null, inboundSizes?: Array<{ brandId: string, productId: string, quantity: number } | null> | null, deliveredSizes?: Array<{ brandId: string, productId: string, quantity: number } | null> | null }> | null };

export type DabHistoryQueryVariables = Types.Exact<{
  query: Types.DabQuery;
}>;


export type DabHistoryQuery = { dabHistory?: Array<{ quantity: number, order: string, deliveryDate: string, title: string, color: string, type: Types.DabHistoryType, productId: string, brandId: string, address: { city?: string | null, countryCode?: string | null, stateCode?: string | null, street?: string | null } }> | null };

export const DabDocument = gql`
    query Dab($query: DabQuery!) {
  dab(query: $query) {
    brandId
    productId
    rootId
    basketItemsQuantity
    inboundItemsQuantity
    deliveredItemsQuantity
    hasInboundItemsIcon
    inboundSizes {
      brandId
      productId
      quantity
    }
    deliveredSizes {
      brandId
      productId
      quantity
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DabGQL extends Apollo.Query<DabQuery, DabQueryVariables> {
    document = DabDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DabHistoryDocument = gql`
    query DabHistory($query: DabQuery!) {
  dabHistory(query: $query) {
    quantity
    order
    deliveryDate
    title
    address {
      city
      countryCode
      stateCode
      street
    }
    color
    type
    productId
    brandId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DabHistoryGQL extends Apollo.Query<DabHistoryQuery, DabHistoryQueryVariables> {
    document = DabHistoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }